<template>
  <a
    class="icp-filing-link"
    href="https://beian.miit.gov.cn/"
    target="_blank"
    rel="noopener noreferrer"
  >苏ICP备2026033741号</a>
</template>
